import React, { useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { makeCommonNavigation } from '../../../../base/infrastructure/navigation';
import { stringPramsToObject } from '../../../../base/infrastructure/helpers';
import {
  makeCommonDataSource,
  makeCommonTransformer,
} from '../../../../base/domain/factories';
import {
  IBaseDataSourceRepository,
  IBaseNavigationRepository,
  IBaseTransformerRepository,
} from '../../../../base/domain/repositories';
import {
  BaseEntity,
  PageActionEntity,
  PageProviderPropsEntity,
  PageProviderHookEntity,
} from '../../../../base/domain/entities';
import {
  useFilterDataTable,
  useMetaDataTable,
} from '../../../../base/presentation/hooks';

export const PageProviderContext = React.createContext<
  PageProviderHookEntity<any, any, any, any, any>
>(null);

export function PageProvider<
  PayloadEntity extends BaseEntity = BaseEntity,
  IDataSource extends IBaseDataSourceRepository<
    PayloadEntity
  > = IBaseDataSourceRepository<PayloadEntity>,
  ITransformer extends IBaseTransformerRepository = IBaseTransformerRepository,
  INavigation extends IBaseNavigationRepository = IBaseNavigationRepository
>(
  props: PageProviderPropsEntity<
    PayloadEntity,
    IDataSource,
    ITransformer,
    INavigation
  >
): JSX.Element {
  const { initialValue, children } = props;

  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();

  const commonTransformer = makeCommonTransformer<PayloadEntity>();
  const commonNavigation = makeCommonNavigation({
    webUrl: initialValue?.webUrl ?? '',
    navigate,
  });
  const commonDataSource = makeCommonDataSource<PayloadEntity>({
    apiUrl: initialValue?.apiUrl ?? '',
    baseUrl: initialValue?.baseApiUrl,
  });

  const search = location.search;
  const searchParams = stringPramsToObject(search);
  const action: PageActionEntity = params?.action as any;
  const isCreate = action === 'create';
  const isUpdate = action === 'update';
  const isDetail = action === 'detail';
  const isDuplicate = action === 'duplicate';
  const id = searchParams?.id;

  const transformer = initialValue?.transformer ?? commonTransformer;
  const navigation = initialValue?.navigation ?? commonNavigation;
  const dataSource = initialValue?.dataSource ?? commonDataSource;
  const queryPrams = searchParams;
  const apiUrl = initialValue?.apiUrl;
  const webUrl = initialValue?.webUrl;
  const baseApiUrl = initialValue?.baseApiUrl;
  const moduleKey = initialValue?.moduleKey;

  const [loadingDataTable, setLoadingDataTable] = useState(false);
  const [recordDataTable, setRecordDataTable] = useState([]);
  const [selectedDataTable, setSelectedDataTable] = useState([]);
  const [metaDataTable, setMetaDataTable] = useMetaDataTable(moduleKey);
  const [filterDataTable, setFilterDataTable] = useFilterDataTable(moduleKey);
  // const defaultDetailData = searchParams?.id
  //   ? recordDataTable.find((item) => item.id?.toString() === searchParams?.id)
  //   : undefined;
  const defaultDetailData = undefined;
  const [detailData, setDetailData] = useState(defaultDetailData);

  const PageProviderValue: PageProviderHookEntity = {
    id,
    webUrl,
    apiUrl,
    action,
    isCreate,
    isDetail,
    isUpdate,
    moduleKey,
    queryPrams,
    baseApiUrl,
    isDuplicate,

    transformer,
    navigation,
    dataSource,

    recordDataTable,
    setRecordDataTable,
    selectedDataTable,
    setSelectedDataTable,
    metaDataTable,
    setMetaDataTable,
    filterDataTable,
    setFilterDataTable,
    detailData,
    setDetailData,
    loadingDataTable,
    setLoadingDataTable,
    defaultDetailData,
  };

  return (
    <React.Fragment>
      <PageProviderContext.Provider value={PageProviderValue}>
        {children}
      </PageProviderContext.Provider>
    </React.Fragment>
  );
}
